import { createRoute } from "../../../utils";

import {
  courseChapterSlidesRoutesObj,
  courseChapterSlidesBreadcrumbs,
} from "./path";

import type { IRouteMetadataObj } from "@routes/types";
import { IRole } from "@/interfaces";

const permission = [IRole.FACULTY_MEMBER];

const courseChapterSlidesRouteMetadata: IRouteMetadataObj<
  typeof courseChapterSlidesRoutesObj
> = {
  create: {
    title: "addNewSlide",
    lazy: () =>
      import(
        "@/pages/facultyMemberPanel/courseManagement/courseChapterSlides/page"
      ),
    mode: "create",
    permission,
  },
  edit: {
    title: "editSlideOf",
    lazy: () =>
      import(
        "@/pages/facultyMemberPanel/courseManagement/courseChapterSlides/page"
      ),
    mode: "edit",
    permission,
  },
  view: {
    title: "viewSlideOf",
    lazy: () =>
      import(
        "@/pages/facultyMemberPanel/courseManagement/courseChapterSlides/page"
      ),
    mode: "view",
    permission,
  },
};

export const courseChapterSlidesRoutes = createRoute<
  typeof courseChapterSlidesRoutesObj
>(
  courseChapterSlidesRoutesObj,
  courseChapterSlidesRouteMetadata,
  courseChapterSlidesBreadcrumbs,
);
